import React, { useState } from "react";
import UserListByBoat from "./UserListByBoat";

import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Badge from 'react-bootstrap/Badge';

import { FaUser, FaEyeSlash, FaEye } from "react-icons/fa";
import type { Boat } from "../types/types";



const BoatsList: React.FC<{boat: Boat}> = ({ boat }) => {

    const [isExpanded, setIsExpanded] = useState(false);

    const handleToggleUsers  = () => {
        setIsExpanded(prevState => !prevState)
    }

    return (
        <ListGroup.Item
                key={boat.id}
                className="p-3 border-bottom d-flex align-items-center justify-content-between rounded transition list-ub"
        >
            <div>
                <div className="d-flex align-items-center gap-2">
                    <strong>{boat.code_pf}</strong>
                    <Badge pill bg="warning" >{boat.nom_bateau}</Badge>
                </div>
                {isExpanded && (
                    <UserListByBoat boatId={boat.id}></UserListByBoat>
                )}
            </div>
            <div className="d-flex align-items-center g-4">
                <Button
                    variant="primary"
                    size="sm"
                    className="px-3 py-1 text-white rounded"
                    onClick={() =>handleToggleUsers()}>
                    <div className="d-flex align-items-center justify-content-between">
                        {isExpanded ? <FaEyeSlash/> : <FaEye/>} <FaUser/>
                    </div>
                </Button>
            </div>
        </ListGroup.Item>
    );
           
};

export default BoatsList;
